<button class="inchat-fab" type="button" aria-label="Abrir INChat" (click)="togglePreview()">
	<svg class="inchat-fab__bg" viewBox="0 0 80 80"><circle class="inchat-fab__bg-circle" /></svg>
	@if (!isPreviewOpen && !isChatOpen) {
		<svg class="inchat-fab__icon" viewBox="0 0 43 43">
			<path
				class="inchat-fab__icon-path"
				d="M21.5 6C13.2 6 6.5 11.7 6.5 18.8c0 3.5 1.6 6.7 4.5 9.1v5.2c0 .8.9 1.3 1.6.8l5.2-3.5c1.1.2 2.3.3 3.5.3 8.3 0 15-5.7 15-11.9S29.8 6 21.5 6Z"
			/>
			<circle class="inchat-fab__icon-dot inchat-fab__icon-dot--1" />
			<circle class="inchat-fab__icon-dot inchat-fab__icon-dot--2" />
			<circle class="inchat-fab__icon-dot inchat-fab__icon-dot--3" />
		</svg>
	} @else {
		<svg
			class="inchat-fab__icon inchat-fab__icon--close"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path class="inchat-fab__icon-close-path" d="M30 10L10 30" />
			<path class="inchat-fab__icon-close-path" d="M10 10L30 30" />
		</svg>
	}
	@if (hasUnreadMessages && !isChatOpen && !isPreviewOpen) {
		<span class="inchat-fab__badge"></span>
	}
</button>
@if (isPreviewOpen) {
	<section class="inchat-preview">
		<header>
			<img
				appConcatenateSrc="a7159591-4e96-4159-9c1e-77fc80a8e3c0-logo&icon.svg"
				alt="INChat Icon"
				class="inchat-preview__logo-icon"
			/>
			<img
				appConcatenateSrc="52dba03e-d69c-4cd0-9be6-53aaa4690516-logo&text.svg"
				alt="INChat Text"
				class="inchat-preview__logo-text"
			/>
		</header>
		<button class="inchat-support-card" type="button" (click)="openChat()">
			<span><strong>Soporte general</strong></span>
			<img
				appConcatenateSrc="69e34274-7cdd-42d3-a7c1-b915d50df4d2-robotinchat.svg"
				alt="Robot asistente INChat"
			/>
		</button>
	</section>
}
@if (isChatOpen) {
	<app-modal-chatbot (closed)="closeChat()" (back)="returnToPreview()"></app-modal-chatbot>
}
